import PropTypes from 'prop-types'
import classNames from 'classnames'
import { get } from 'lodash'

const Media = ({ webinar, ...attrs }) => {
  const backgroundImageUrl = get(webinar, 'headerImageListStandar.url', null)

  return <div
    className={
      classNames([
        'relative',
        'bg-no-repeat',
        'bg-center',
        'bg-cover',
        'p-6'
      ])
    }
    style={{
      height: '12rem',
      borderRadius: '0 2.5rem 2.5rem 2.5rem',
      backgroundImage: backgroundImageUrl ? `url('${backgroundImageUrl}')` : null
    }}>
  </div>
}

Media.propTypes = {
  webinar: PropTypes.object
}

export default Media
